var jQuery = require('jquery');
import * as ko from 'knockout';
const io = require('socket.io-client');

import './knockout/fileuploader.js';
import { addNotification } from './notifications';
import { uuidv4 } from './utils.js';

function UploadArea(data)
{
    var self = this;
    var socket;

    data = data || {};

    self.element_id         = data.element_id;
    self.entity_id          = data.entity_id;
    self.parent_id          = data.parent_id;
    self.entity_name        = data.entity_name;
    self.upload_type        = data.upload_type;
    self.acceptedFileTypes  = data.acceptedFileTypes;
    self.file_url           = data.file_url;
    self.status             = data.status;
    self.task_log           = data.task_log;
    self.media_type         = data.media_type;
    self.generate_parent_id = data.generate_parent_id;
    
    if( data.uploadKey )
        self.uploadKey      = data.uploadKey;
    else
        self.uploadKey      = ko.observable();

    self.upload_status      = ko.observable('init');
    self.upload_progress    = ko.observable();
    self.transcode_progress = ko.observable();
    self.transcode_log      = ko.observable();
    self.uuid               = ko.observable(uuidv4());

    self.activeSocket       = ko.observable(true);

    self.pauseUpload = function() {
        document.dispatchEvent(new CustomEvent("uploader.pauseUpload", {detail: { uuid: self.uuid()}}));
        self.upload_status('uploading-paused');
    };

    self.resumeUpload = function() {
        document.dispatchEvent(new CustomEvent("uploader.resumeUpload", {detail: { uuid: self.uuid()}}));
        self.upload_status('uploading');
    };

    self.stopUpload = function() {
        document.dispatchEvent(new CustomEvent("uploader.stopUpload", {detail: { uuid: self.uuid()}}));
        self.upload_status('init');
    };

    if( typeof client_key !== 'undefined' )
    {
        socket = io( monitor_server_url );

        socket.on( 'connect', function()
        {
            socket.emit( 'link_client', client_key );
        });

        socket.on( 'bad_token', function( msg )
        {
            console.log( 'bad_token', msg );
        });

        socket.on( 'client_linked', function( msg )
        {
            self.activeSocket(true);
        });

        socket.on( 'transcoder_update', function( msg )
        {
            if( self.uploadKey() !== undefined && msg.upload_key === self.uploadKey() )
            {
                self.upload_status('transcoding');
                self.transcode_progress(msg.percentage);
                self.transcode_log(msg.log);

                if( msg.percentage === 0 )
                {
                    if( self.upload_type === 'asset_video' )
                    {
                        self.status('transcoding');
                        // Redirect to new url
                        if( msg.asset_id ) {
                            self.entity_id(msg.asset_id);
                            window.history.pushState("", "", '/assets/' + msg.asset_id);
                        }
                    }
                    else if( self.upload_type === 'track_video' )
                    {
                        self.entity_id('upload-complete');
                    }
                    else if( self.upload_type === 'mix_background_video_loop' )
                    {
                        self.entity_id('upload-complete');
                    }
                    else if( self.upload_type === 'playlist_background_video_loop' )
                    {
                        self.entity_id('upload-complete');
                    }
                    else if( self.upload_type === 'track_background_video' )
                    {
                        self.entity_id('upload-complete');
                    }
                    else if( self.upload_type === 'track_audio' )
                    {   
                        // Redirect to new url
                        if( msg.track_id ) 
                        {
                            self.entity_id(msg.track_id);
                            window.history.pushState("", "", '/catalog/' + msg.track_id + '?nav=new');
                        }
                    }
                    else if( self.upload_type === 'mix_audio' )
                    {   
                        self.status('transcoding');
                        // Redirect to new url
                        if( msg.mix_id ) 
                        {
                            self.entity_id(msg.mix_id);
                            self.media_type('audio');
                            window.history.pushState("", "", '/mixes/' + msg.mix_id);
                        }
                    }
                    else if( self.upload_type === 'mix_video' )
                    {   
                        self.status('transcoding');
                        // Redirect to new url
                        if( msg.mix_id ) 
                        {
                            self.entity_id(msg.mix_id);
                            self.media_type('video');
                            window.history.pushState("", "", '/mixes/' + msg.mix_id);
                        }
                    }
                }

                if( self.upload_type === 'track_audio' || 
                    self.upload_type === 'asset_video' || 
                    self.upload_type === 'track_video' || 
                    self.upload_type === 'track_background_video' || 
                    self.upload_type === 'mix_audio' || 
                    self.upload_type === 'mix_background_video_loop' || 
                    self.upload_type === 'mix_video' || 
                    self.upload_type === 'playlist_background_video_loop' )
                    self.task_log(msg.log);

                if( msg.status === 'completed' && msg.file ) 
                {
                    addNotification( 'Transcoding file completed', 'success' );
                    self.file_url(msg.file);
                    self.upload_status('transcode-complete');
                    self.status('concept');

                    if( self.upload_type === 'mix_audio' && msg.mix_id) 
                    {
                        self.entity_id(msg.mix_id);
                        self.media_type('audio');
                        window.history.pushState("", "", '/mixes/' + msg.mix_id);
                    }
                    else if( self.upload_type === 'mix_video' && msg.mix_id) 
                    {
                        self.entity_id(msg.mix_id);
                        self.media_type('video');
                        window.history.pushState("", "", '/mixes/' + msg.mix_id);
                    }

                    if( self.upload_type === 'asset_video' || 
                        self.upload_type === 'track_video' || 
                        self.upload_type === 'track_background_video' || 
                        self.upload_type === 'mix_background_video_loop' || 
                        self.upload_type === 'mix_video' || 
                        self.upload_type === 'playlist_background_video_loop' )
                    {
                        if( msg.transcoder_errors && msg.transcoder_errors.length > 0 ) 
                        {
                            var event_details = {uploadKey: self.uploadKey(), transcoder_errors: msg.transcoder_errors};
                            document.dispatchEvent(new CustomEvent("transcoder.errors", {detail: event_details} ));
                            self.status('review');
                        }
                        else if( self.upload_type === 'playlist_background_video_loop' && self.parent_id() && window.location.href.substring(window.location.href.length - 3) === 'new' )
                        {
                            if( navigation_page !== null )
                                window.location.href = "/channel/" + channel_slug +  "/playlist/" + self.parent_id() + "/?nav=" + navigation_page;
                            else
                                window.location.href = "/channel/" + channel_slug +  "/playlist/" + self.parent_id();
                        }
                    }

                }
                else if( msg.status === 'error' )
                {
                    console.log('transcoder_update ERROR', msg);
                    addNotification( msg.log, 'error' );
                    self.status('error');
                    self.upload_status('error');
                }
            }
        });

        socket.on( 'disconnect', function()
        {
            console.log( 'disconnected' );
            self.activeSocket(false);
        });
    }

    document.addEventListener("uploader.status.init", (evt) => {
        self.upload_status('init');
    });

    return self;
}

export { UploadArea };